import * as Yup from 'yup'

const questionnaireSchema = Yup.object().shape({
    questions: Yup.array().of(
        Yup.object().shape({
            questionTitle: Yup.string().required('Required'),
            questionOptions: Yup.array()
                .of(
                    Yup.object().shape({
                        text: Yup.string().required('Required'),
                        correct: Yup.boolean(),
                    })
                )
                .min(1, 'At least one option is required'),
            correctAnswer: Yup.string().test({
                name: 'required-if-options-present',
                message: 'Please select a correct answer',
                test: function (value) {
                    const options = this.parent.questionOptions
                    return options && options.length > 0
                        ? value !== undefined && value !== ''
                        : true
                },
            }),
        })
    ),
    questionnaireTitle: Yup.string().required('Required'),
    passingScore: Yup.number().required('Required'),
})

export { questionnaireSchema }
